package app.api

import app.client
import app.model.RolloutExecution
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import kotlinx.coroutines.Job

class RolloutExecutionApi : RootStore<RolloutExecution?>(null, job = Job()) {
    val handler = handle { _, id: String ->
        client.get(Routing.RolloutExecutions.Id(id = id.toInt())).body<RolloutExecution>()
    }
}
